const { default: app } = require("@/store/app")
const { BIconSortAlphaUpAlt } = require("bootstrap-vue")

window.$loading = function (isShow) {
  const appLoading = document.getElementById('loading-bg')
  const html = document.querySelector('html')
  if (html && appLoading) {
    if (isShow == true) {
      // html.style.overflow = 'hidden'
      return (appLoading.style.display = '')
    }
    html.style.overflow = ''
    return (appLoading.style.display = 'none')
  }
}
